import styled from 'styled-components'
import { DatasetType } from '../../../../api/generated'

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const Heading = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #2d2f48;
  margin: 0;
`

export const StatusBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const TypeBadge = styled.div<{ type: DatasetType }>`
  font-size: 12px;
  font-weight: 600;
  color: ${({ type }) => (type === DatasetType.Sql ? '#1E88E5' : '#6A1B9A')};
  background-color: ${({ type }) => (type === DatasetType.Sql ? 'rgba(30, 136, 229, 0.1)' : 'rgba(106, 27, 154, 0.1)')};
  border: 1px solid ${({ type }) => (type === DatasetType.Sql ? '#BBDEFB' : '#E1BEE7')};
  padding: 2px 8px;
  border-radius: 12px;
  text-transform: uppercase;
`

export const StatusTag = styled.span<{ isActive: boolean }>`
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ isActive }) => (isActive ? '#2E7D32' : '#C62828')};
  background-color: ${({ isActive }) => (isActive ? 'rgba(46, 125, 50, 0.1)' : 'rgba(198, 40, 40, 0.1)')};
  border: 1px solid ${({ isActive }) => (isActive ? '#C8E6C9' : '#FFCDD2')};
  margin-bottom: 4px;
`

export const SmallMeta = styled.small`
  font-size: 12px;
  opacity: 0.75;
`
